{
  "de": {
    "choice": {
      "actions": {
        "delete_choice": "Option entfernen",
        "delete_choice_list": "Optionsliste entfernen"
      },
      "labels": {
        "not_selected": "Nicht ausgewählt",
        "selected": "Ausgewählt"
      },
      "messages": {
        "delete_choice": "Sind Sie sicher, dass Sie die Option {title} entfernen möchten?",
        "delete_choice_list": "Sind Sie sicher, dass Sie die Optionsliste {title} entfernen möchten?"
      },
      "toasts": {
        "create": "Option wurde erfolgreich erstellt",
        "delete": "Option wurde erfolgreich gelöscht",
        "update": "Option wurde erfolgreich aktualisiert"
      }
    }
  }
}
